import React from "react";
import { arrow, blackarrow, specialoffer1, specialoffer2 } from "../Constant/Index";

function Specialoffer() {
  return (
    <>
      {/* Special Offer Section  */}
      <section className="special-offer-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="special-offer-dv">
                <div className="special-offer">
                  <span>--special offer</span>
                  <h2 className="primary-color">Get 50% OFF</h2>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur <br /> adipiscing
                    elit, sed do eiusmod tem
                  </p>
                </div>
                <div className="special-offer-btn">
                  <button>
                    shop now{" "}
                    <img
                      src={arrow}
                      alt="special-offer"
                      className="img-fluid"
                    />
                  </button>
                </div>
                <div className="special-offer-img">
                  <img
                    src={specialoffer1}
                    alt="special-offer"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="special-offer-dv "style={{backgroundColor : "#E0B797"}}>
                <div className="special-offer">
                  <span style={{color : "#000000"}}>--special offer</span>
                  <h2 className="primary-color">Get 50% OFF</h2>
                  <p style={{color : "#000000"}}>
                    Lorem ipsum dolor sit amet, consectetur <br /> adipiscing
                    elit, sed do eiusmod tem
                  </p>
                </div>
                <div className="special-offer-btn">
                  <button style={{color : "#000000"}}>
                    shop now{" "}
                    <img
                      src={blackarrow}
                      alt="special-offer"
                      className="img-fluid"
                    />
                  </button>
                </div>
                <div className="special-offer-img2">
                  <img
                    src={specialoffer2}
                    alt="special-offer"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ==================== */}
    </>
  );
}

export default Specialoffer;
